import Client from './Client';

export default class RegistrationClient {
  constructor() {
    this.client = Client;
  }

  /**
   * 获取学员报名列表
   */
  async getList(data) {
    const res = await this.client.post('/api/course/registration/page', data);
    return res;
  }

  /**
   * 获取有报名的机构
   */
  async listNameByRegistration() {
    const res = await this.client.post('/api/agency/listNameByRegistration');
    return res;
  }

  /**
   * 获取有报名的分类
   */
  async listCategoryByRegistration() {
    const res = await this.client.post('/api/course/listCategoryByRegistration');
    return res;
  }

  /**
   * 新增报名信息
   */
  async registrationInsertBackend(data) {
    const res = await this.client.post('/api/course/registration/insertBackend', data);
    return res;
  }

  /**
   * 根据手机号查询用户信息
   */
  async getBindByMobile(data) {
    const res = await this.client.post('/api/user/getBindByMobile', data);
    return res;
  }

  /**
   * 考试审核列表
   */
  async pageVideoExamRecordBackend(data) {
    const res = await this.client.post('/api/exam/pageVideoExamRecordBackend', data);
    return res;
  }

  /**
   * 学习进度列表
   */
  async pageProgress(data) {
    const res = await this.client.post('/api/course/registration/pageProgress', data);
    return res;
  }
}